module.exports = __webpack_public_path__ + "img/ico_app.ef9a35e5.png";